module.exports = __webpack_public_path__ + "media/images/liv__squiggle__bg-80c6005424fdb25816a73432f7259ab0.png";